import MessageSender from '../sender'
import BaseMessage from '../message'

export default () => async () => {
  const msg = new BaseMessage()
  msg.setPath('data/transfer_purpose_list')

  const response = await new MessageSender().doGet(msg)

  return response
}
